import React from 'react'
import PropTypes from 'prop-types'

const Button = ({ label, onClick, className, disabled, color, backgroundcolor, value, style, type }) => {
  const classMapping = {
    save: 'savebutton',
    cancel: 'cancelbutton',
    clear: 'clearbutton',
    delete: 'deletebutton',
    add: 'addbutton',
    update: 'savebutton',
  }

  const mappedClass =
    typeof label === 'string' ? classMapping[label.toLowerCase()] || '' : ''

  return (
    <button
      // Without this a button inside a form defaults to submit, so Cancel and
      // the like would submit the form as well as run their own handler
      type={type}
      style={{
        backgroundColor: backgroundcolor,
        color: color,
        opacity: disabled ? 0.6 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
        ...style,
      }}
      onClick={onClick}
      value={value}
      className={`${className} ${mappedClass}`}
      disabled={disabled}
    >
      {label}
    </button>
  )
}

Button.propTypes = {
  label: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.any,
  color: PropTypes.string,
  value: PropTypes.string,
  backgroundcolor: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
}

Button.defaultProps = {
  label: '',
  onClick: () => {},
  className: '',
  disabled: false,
  value: '',
  type: 'button',
}

export default Button